import axios from 'axios';
// import forge from 'node-forge';
import { store } from '../redux/store';
import { reduxUpdateError } from '../redux/reducers/error';
import Cookies from 'universal-cookie';

// https://api.dragify.ai
// http://127.0.0.1:4000
export const webURL = 'https://dev.dragify.ai';
// https://console.dragify.ai
// http://localhost:3001
export const consoleURL = 'https://dev-console.dragify.ai';

// https://api.dragify.ai/proxy/api
// http://127.0.0.1:4000/proxy/api
export const baseURL = 'https://api.dragify.ai/proxy/api';

// const normalizeOrigin = (value: string): string => value.replace(/\/+$/, '');

// Runtime contracts:
// REACT_APP_API_ORIGIN, REACT_APP_BASE_API_URL, REACT_APP_CONSOLE_ORIGIN
// export const webURL = normalizeOrigin(process.env.REACT_APP_API_ORIGIN || 'http://127.0.0.1:4000');
// export const consoleURL = normalizeOrigin(process.env.REACT_APP_CONSOLE_ORIGIN || 'http://localhost:3001');
// export const baseURL = normalizeOrigin(process.env.REACT_APP_BASE_API_URL || `https://api.dragify.ai/proxy/api`);

export const baseURLExecute = () => {
   const cookies = new Cookies();
   const token = cookies.get('token');
   axios.defaults.baseURL = baseURL;
   axios.defaults.headers.common = { 'x-auth-token': token };
}

// ---
export const interceptorExecute = () => {
   axios.interceptors.request.use(
      (config) => {
         // if (config.url?.startsWith('/')) {
         //    if (!config.headers['Content-Type']) {
         //       if (typeof config.data === 'object' && !(config.data.append && config.data.forEach)) {
         //          config.headers['Content-Type'] = 'application/json';
         //       }
         //    }
         //    const contentType = config.headers['Content-Type'];

         //    if (contentType === 'application/json') {
         //       console.log(config.data);
         //       config.data = encryptData(config.data);
         //    }
         // } 
         return config;
      }, (error) => {
         return Promise.reject(error);
      }
   );
   // Listen to all errors and show them
   axios.interceptors.response.use(
      (response) => response,
      function (error) {
         console.log('error', error);
         if (window.location.pathname === '/workflow') {
            const message = error?.response?.data || error?.message || error?.request || 'An error occurred';
            store.dispatch(reduxUpdateError(JSON.stringify(message, null, 1)/* .replace(/\\/g, " ") */));
         }
         return Promise.reject(error);
      }
   );
}

// Cancel All Requests
let cancelTokenSource = axios.CancelToken.source();
const resetCancelTokenSource = () => { cancelTokenSource = axios.CancelToken.source() };

export const applyCancelTokenInterceptor = () => {
   axios.interceptors.request.use(config => {
      config.cancelToken = cancelTokenSource.token;
      return config;
   });
};

// ---
export const cancelAllRequests = () => {
   cancelTokenSource.cancel();
   resetCancelTokenSource();
}

// ---
// const encryptData = (data: any) => {
//    const rsa = forge.pki.publicKeyFromPem(store.getState().user.data?.EndToEnd.publicKey as string);
//    // Generate a random AES key
//    const aesKey = forge.random.getBytesSync(16); // 128-bit AES key
//    const iv = forge.random.getBytesSync(16); // Initialization vector
//    // Encrypt the data using AES
//    const cipher = forge.cipher.createCipher('AES-CBC', aesKey);
//    cipher.start({ iv: iv });
//    cipher.update(forge.util.createBuffer(JSON.stringify(data), 'utf8'));
//    cipher.finish();
//    const encryptedData = cipher.output;
//    // Encrypt the AES key using RSA
//    const encryptedAesKey = rsa.encrypt(aesKey, 'RSA-OAEP', { md: forge.md.sha256.create() });
//    // Encode the results in base64
//    return {
//       RSA: forge.util.encode64(encryptedAesKey),
//       iv: forge.util.encode64(iv),
//       encryptedData: forge.util.encode64(encryptedData.getBytes())
//    };
// };